<template>
  <div>
    <div class="page-loading" v-loading="true">
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageLoading',
  data() {
    return {
    };
  },
}
</script>

<style scoped>
.page-loading {
  width: 100vw;
  height: 100vh;
}
</style>